module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "xitongxiaoxi"
  }, [_c('div', {
    staticClass: "xt-title"
  }, [_vm._v(_vm._s(_vm.$t('all.xitongxiaoxi')))]), _vm._v(" "), _c('div', {
    ref: "listContainer",
    staticClass: "xt-list",
    on: {
      "scroll": _vm.handleScroll
    }
  }, [_vm._l((_vm.list), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "xt-list-item"
    }, [_c('div', {
      staticClass: "xt-list-item-title"
    }, [_c('div', {
      staticClass: "xt-list-item-title-left"
    }, [_c('img', {
      attrs: {
        "src": require("../../assets/image/xitongxiaoxi_18_1@2x.png"),
        "alt": ""
      }
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('all.xitongxiaoxi')))])]), _vm._v(" "), _c('span', {
      staticClass: "xt-list-item-title-span"
    }, [_vm._v(_vm._s(item.createTime))])]), _vm._v(" "), _c('div', {
      staticClass: "xt-list-item-content",
      domProps: {
        "innerHTML": _vm._s(_vm.formatContent(item.content))
      }
    })])
  }), _vm._v(" "), (_vm.isKong) ? _c('kong') : _vm._e()], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c35c95be"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/xitongxiaoxi/xitongxiaoxi.vue
// module id = 998
// module chunks = 1